import styled from 'styled-components';
import {
  space,
  SpaceProps,
  ColorProps,
  TypographyProps,
  LayoutProps,
  layout,
  typography,
  color,
  WidthProps,
  width,
} from 'styled-system';
import { font } from '../../theme/font';
import { colors } from '../../theme/colors';

export interface BoxProps extends SpaceProps, LayoutProps, TypographyProps, ColorProps, WidthProps {
  as?: React.ElementType;
}

export const Box = styled.div<BoxProps>`
  ${layout}
  ${space}
  ${typography}
  ${color}
  ${width}
  box-sizing: border-box;
`;

Box.defaultProps = {
  fontFamily: font.fonts.brand,
  color: colors.kilamanjaro,
};

Box.displayName = 'Box';
